import React from 'react'
import {
  roomAssistanceStatusChange,
  popupOpenClose,
  requesForButler,
  setLoadingMass
} from '../../action/action'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';

class RoomAssistance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      yesForButler: false,
      requestStatus: false
    }
  }
  onNoClick = () => {
    this.props.roomAssistanceStatusChange(false);
  }
  onYesClick = () => {
    let sessionToken = "8f67428d-3925-49bc-b9a5-756e2381ff17"//localStorage.getItem('GuestJourneySessionToken');
    if (sessionToken) {
      this.props.requesForButler(sessionToken, this.callbackFunction);
      this.props.setLoadingMass(true);
      //this.props.roomAssistanceStatusChange(false);
    }
  }

  callbackFunction = (status) => {
    this.setState({ yesForButler: true, requestStatus: status });
    //this.props.roomAssistanceStatusChange(true);
      this.props.setLoadingMass(false);
  }

  render() {
    return (
      <div className="overlay">
        <div id="svc" className="overlay-body">
          <div className="overlay-close" onClick={this.onNoClick}>
            <i className="fa fa-close"></i>
          </div>
          {!this.state.yesForButler ?
            <div className="primary-response center">
              <div className="wide" style={{ fontSize: '20px' }}>
                {this.props.stringConst.roomAssis}
              </div>
              <button className="btn-yes" onClick={this.onYesClick} style={{ border: "none" }}>
                {this.props.stringConst.yes}
              </button>
              <button className="btn-no" onClick={this.onNoClick} style={{ border: "none" }}>
                {this.props.stringConst.no}
              </button>
            </div> :
            <div className="response">
              {
                this.props.guestInRoom ?
                  this.state.requestStatus ?
                    this.props.stringConst.roomAssisRes
                    : "request for butler is failed."
                  : "you must be in hotel room to use this feature."}
            </div>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    roomAssistancePageStatus: state.store.roomAssistance.popupStatus,
    stringConst: state.store.home.stringConst,
    guestInRoom: state.store.guestInRoom
  }
}

RoomAssistance.propTypes = {
  roomAssistancePageStatus: PropTypes.bool,
  stringConst: PropTypes.object
}

export default connect(
  mapStateToProps,
  {
    roomAssistanceStatusChange,
    popupOpenClose,
    requesForButler,
    setLoadingMass
  }
)(RoomAssistance);